<mat-form-field>
  <mat-label>Anställningsdatum, start och slutdatum</mat-label>
  <mat-date-range-input [rangePicker]="rangePicker">
    <input #tr=ngModel matStartDate
           required
           placeholder="Startdatum"
           [(ngModel)]="start"
    >
    <input #tr=ngModel matEndDate
           required
           placeholder="Slutdatum"
           [(ngModel)]="end">
  </mat-date-range-input>
  <mat-hint>ÅÅÅÅ-MM-DD – ÅÅÅÅ-MM-DD</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="rangePicker"/>
  <mat-date-range-picker #rangePicker/>
</mat-form-field>
